import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { MessageCircle, Sparkles } from "lucide-react";
import { useApp } from "@/context/AppContext";

export default function AskExpert() {
  const { settings } = useApp();
  const [form, setForm] = useState({ name:"", phone:"", email:"", car_brand:"", car_model:"", car_year:"", modification_type:"", question:"", car_photo:"", product_photo:"" });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const set = (k, v) => setForm((s) => ({ ...s, [k]: v }));

  const fileToBase64 = (file) => new Promise((res, rej) => {
    const r = new FileReader(); r.onload = () => res(r.result); r.onerror = rej; r.readAsDataURL(file);
  });

  const onFile = async (k, e) => {
    const f = e.target.files?.[0]; if (!f) return;
    const b64 = await fileToBase64(f); set(k, b64);
  };

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/expert-questions", form);
      setDone(true);
      toast.success("Question sent!");
    } catch { toast.error("Could not send. Please try again."); }
    setSubmitting(false);
  };

  return (
    <div className="max-w-[1400px] mx-auto px-4 md:px-8 py-10 md:py-16" data-testid="ask-expert-page">
      <div className="grid md:grid-cols-2 gap-10">
        <div>
          <div className="overline text-[#E63946] mb-3">Ask an Expert</div>
          <h1 className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95]">Not Sure What Your Car Needs? <span className="text-[#E63946]">Ask Us.</span></h1>
          <p className="mt-5 text-white/70 max-w-lg">Tell us what you're looking to modify, personalize or improve, and our team will help point you in the right direction.</p>
          <div className="mt-8 space-y-3">
            <a href={`https://wa.me/91${settings?.whatsapp || ""}`} target="_blank" rel="noreferrer" className="sa-btn sa-btn-primary">
              <MessageCircle size={16} /> CHAT WITH US ON WHATSAPP
            </a>
            <div className="text-sm text-white/60">Or fill out the form. We respond within 24 hours.</div>
          </div>
        </div>

        {done ? (
          <div className="bg-[#111] border border-white/10 p-8 flex flex-col items-center text-center">
            <Sparkles size={44} className="text-[#E63946] mb-4"/>
            <h2 className="font-display text-3xl mb-3">Thanks for contacting Street Auto Accessories.</h2>
            <p className="text-white/60">Our team will review your question and get back to you.</p>
          </div>
        ) : (
          <form onSubmit={submit} className="bg-[#111] border border-white/10 p-6 md:p-8 space-y-4">
            <div className="grid sm:grid-cols-2 gap-4">
              <input required placeholder="Name" className="sa-input" value={form.name} onChange={(e) => set("name", e.target.value)} data-testid="expert-name" />
              <input required placeholder="Phone" className="sa-input" value={form.phone} onChange={(e) => set("phone", e.target.value)} data-testid="expert-phone" />
              <input required type="email" placeholder="Email" className="sa-input sm:col-span-2" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="expert-email" />
              <input placeholder="Car Brand" className="sa-input" value={form.car_brand} onChange={(e) => set("car_brand", e.target.value)} />
              <input placeholder="Car Model" className="sa-input" value={form.car_model} onChange={(e) => set("car_model", e.target.value)} />
              <input placeholder="Car Year" className="sa-input" value={form.car_year} onChange={(e) => set("car_year", e.target.value)} />
              <input placeholder="What are you looking to modify?" className="sa-input" value={form.modification_type} onChange={(e) => set("modification_type", e.target.value)} />
            </div>
            <textarea required rows={5} placeholder="Your question" className="sa-input" value={form.question} onChange={(e) => set("question", e.target.value)} data-testid="expert-question"></textarea>
            <div className="grid sm:grid-cols-2 gap-4">
              <label className="text-xs text-white/60">Car photo (optional)<input type="file" accept="image/*" onChange={(e) => onFile("car_photo", e)} className="block mt-2 text-sm" /></label>
              <label className="text-xs text-white/60">Product/reference photo (optional)<input type="file" accept="image/*" onChange={(e) => onFile("product_photo", e)} className="block mt-2 text-sm" /></label>
            </div>
            <button disabled={submitting} className="sa-btn sa-btn-primary w-full" data-testid="expert-submit">{submitting ? "SENDING..." : "SEND QUESTION"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
